import React, { useEffect, useRef, useState } from 'react'
import Streaming from '../../../../services/_realtime/price/Streaming';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import WatchlistAddModal from '../../../../components/watchlistComponents/watchlistAddModal';
import { faArrowRotateRight, faChartLine, faGear, faGripDotsVertical, faSort, faSortDown, faSortUp, faSquareCheck, faSquareChevronRight, faStar } from '@fortawesome/pro-solid-svg-icons';

import { useNavigate } from 'react-router-dom';

import '@grapecity/wijmo.styles/wijmo.css';
import * as wjcCore from '@grapecity/wijmo';
import { FlexGrid, FlexGridColumn } from '@grapecity/wijmo.react.grid';

import { double, formatNumber } from '../../../../formatters/number-formatter-functional';
import Blinker from '../../../../components/blinker/Blinker';
import moment from 'moment';
import { createRoot } from 'react-dom/client';
import Spinner from '../../../../components/spinner';
import { InputText } from 'primereact/inputtext';
import './style.scss';
import { setFavoritesSecuritiesData } from "../../../../stores/auth";
import { Provider } from 'react-redux';
import store from '../../../../stores';
import { Toast } from 'primereact/toast';
import ScoreFields from '../../../../components/score/scoreFields';
import Week52Range from '../../../../components/52WeekRange/52WeekRange';
import { useTranslation } from "react-i18next";
import lodash from 'lodash';
import ErrorView from '../../../../components/alert/error-view';

const IndexAnalysisTable = (props) => {
    let streamingRef = useRef(null);
    const unsubscribeLiveStreaming = useRef(null);
    const toast = useRef(null);
    const [isLoadingTable, setIsLoadingTable] = useState(false);
    const theGridRef = useRef(null);
    const theSearchRef = useRef(null);
    const [gridRows, setGridRows] = useState([]);
    const isSearchInputActive = useRef(false);
    const searchTermRef = useRef('');
    const searchDebounceRef = useRef(null);
    const navigate = useNavigate();
    const cellElements = useRef({});
    const flex = useRef(null);
    const { t } = useTranslation();

    const [columnsData, setColumnsData] = useState([
        {
            binding: "favWatchlist",
            "header": " ",
            "width": 25,
            "align": "left",
            "dataType": "String",
            "visible": true,
            "isRealtimeContent": false,
            "canbeHide": true,
            "visibleIndex": 1,
            "isReadOnly": true,
            "isContentHtml": true,
            "wordWrap": false,
        },
        {
            binding: 'code',
            header: ' ',
            width: 80,
            align: 'left',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'name',
            header: ' ',
            width: 190,
            align: 'left',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'technicalAnalysis',
            header: ' ',
            width: 40,
            align: 'center',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'indicators',
            header: t('tableHeader.indicators'),
            width: 170,
            align: 'center',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'dailyChange',
            header: t('tableHeader.change'),
            width: '*',
            align: 'right',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'lastPrice',
            header: t('tableHeader.last'),
            width: '*',
            align: 'right',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'bid',
            header: t('tableHeader.buyingPrice'),
            width: '*',
            align: 'right',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'ask',
            header: t('tableHeader.sellPrice'),
            width: '*',
            align: 'right',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'range52w',
            header: t('tableHeader.52WeekRange'),
            width: 240,
            align: 'center',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        },
        {
            binding: 'indexWeight',
            header: t('tableHeader.indexWeight'),
            width: '*',
            align: 'right',
            dataType: 'String',
            isVisible: true,
            IsRealtimeContent: true,
            CanbeHide: true,
        }

    ]);

    useEffect(() => {
        if (props.symbolListData.length === 0) {
            setGridRows([]);
            return;
        }

        const objectIds = [];

        props.symbolListData.forEach(item => {
            setupRow(item);
            objectIds.push(item.entityId);
        });

        setGridRows(props.symbolListData);

        const streaming = new Streaming();
        streamingRef.current = streaming;
        const unsubscribe = streaming.subscribe({ objectIds }, (data) => {
            processStreamingData(data);
        });
        unsubscribeLiveStreaming.current = unsubscribe;

        return () => {
            unsubscribe?.Dispose();

            if (streamingRef.current === streaming) streamingRef.current = null;
            if (unsubscribeLiveStreaming.current === unsubscribe) unsubscribeLiveStreaming.current = null;
        };
    }, [props.symbolListData]);

    useEffect(() => {
        applyGridFilter(searchTermRef.current);
    }, [gridRows]);

    useEffect(() => () => clearTimeout(searchDebounceRef.current), []);

    useEffect(() => {
        const handleReload = () => {
            console.log("Reloading data in IndexAnalysisTable...");
        };

        window.addEventListener("reloadData", handleReload);

        return () => {
            window.removeEventListener("reloadData", handleReload);
        };
    }, []);

    const setupRow = (row) => {
        row.pricePrecision = 2;
        row.HistoryRepository = {};
        for (var k = 0; k < columnsData.length; k++) {
            row.HistoryRepository[columnsData[k].binding] = [];
        }
    }

    const processStreamingData = (msg) => {
        if (isSearchInputActive.current) return;

        var cmd = msg['@'];

        if (cmd == undefined) return;

        _lastUpdateTime = moment();

        if (cmd == 'heartbeat') {
            return;
        }

        if (flex.current == undefined) return;

        var changedItems = {};

        let row = flex.current.rows.find((r) => r.dataItem.entityId == cmd);

        if (row == undefined) return;

        changedItems[row.dataItem.entityId] = {};

        var keys = Object.keys(msg);

        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];

            if (key == '@') continue;

            changedItems[row.dataItem.entityId][key] = true;
            row.dataItem[key] = msg[key];

            addHistory(row.dataItem["HistoryRepository"][key], msg[key]);
        }

        updateGrid(changedItems);
    }

    const addHistory = (array, data) => {
        if (array == undefined) return;
        array.push(data);
        if (array.length > 10) {
            array.splice(0, 1);
        }
    }

    const initializeGrid = (flexgrid) => {
        flexgrid.columnHeaders.rows[0].height = 55;
        flexgrid.columnHeaders.rows.defaultSize = 52;
        flexgrid.rows.defaultSize = 55;

        flexgrid.formatItem.addHandler((s, e) => {
            if (e.panel == s.cells) {
                var col = s.columns[e.col];
                var ritem = s.rows[e.row].dataItem;

                if (!cellElements.current[ritem.entityId]) cellElements.current[ritem.entityId] = { item: ritem };
                cellElements.current[ritem.entityId][col.binding] = e.cell;
                formatCell(e.cell, ritem, col, false);

                e.cell.style.margin = 'auto';
                e.cell.style.alignContent = 'center';
            }
            if (e.panel === s.columnHeaders) {
                let column = s.columns[e.col];
                e.cell.style.display = 'flex';
                e.cell.style.alignItems = 'center';

                if (e.panel.grid.columnHeaders.columns[e.col].allowSorting && e.panel.grid.columnHeaders.columns[e.col].binding != "Code") {
                    if (e.cell.innerHTML != '' && e.cell.innerHTML != ' ') {
                        if (e.panel.grid.columnHeaders.columns[e.col].currentSort != "-" && e.panel.grid.columnHeaders.columns[e.col].currentSort != "+") {
                            formatSortHeader(e.cell, col, 'default')
                        }
                        else if (e.panel.grid.columnHeaders.columns[e.col].currentSort != "-") {
                            formatSortHeader(e.cell, col, 'up')
                        }
                        else if (e.panel.grid.columnHeaders.columns[e.col].currentSort != "+") {
                            formatSortHeader(e.cell, col, 'down')
                        }
                    }
                }

                switch (column.align) {
                    case 'left':
                        e.cell.style.justifyContent = 'flex-start';
                        break;
                    case 'center':
                        e.cell.style.justifyContent = 'center';
                        break;
                    case 'right':
                        e.cell.style.justifyContent = 'flex-end';
                        break;
                    default:
                        e.cell.style.justifyContent = 'center';
                }
            }
        });

        flexgrid.scrollPositionChanged.addHandler(() => {
            // invalidateGrid();
        });

        flex.current = flexgrid;
        applyGridFilter(searchTermRef.current);
    };

    const invalidateGrid = () => {
        var _a;
        (_a = flex.current) === null || _a === void 0 ? void 0 : _a.invalidate();
    };

    let _lastUpdateTime = moment();

    const updateGrid = (changedItems) => {
        for (var objectId in changedItems) {
            var itemCells = cellElements.current[objectId];
            if (!itemCells) continue;

            let item = itemCells.item;
            var changedRowColumns = Object.keys(changedItems[objectId]);

            for (var i = 0; i < changedRowColumns.length; i++) {
                var column = flex.current.columns.getColumn(changedRowColumns[i]);

                if (column == undefined) continue;

                var cell = itemCells[column.binding];

                if (!cell) continue;

                formatCell(cell, item, column, true);
            }
        }
    }

    const formatCell = (cell, item, col, flare) => {
        switch (col.binding) {
            case 'lastPrice':
                formatDynamicCell(cell, item, col, flare);
                break;
            case 'rocPrevYear':
            case 'rocPrevWeek':
            case 'rocPrevMonth':
            case 'rocEOFPrevYear':
            case 'dailyChange':
                formatChangeCell(cell, item, col, flare);
                break;
            case 'code':
                formatSymbolCell(cell, item, col, flare);
                break;
            case 'name':
                formatSymbolNameCell(cell, item, col, flare);
                break;
            case 'lastUpdateTime':
                formatLastUpdateTimeCell(cell, item, col, flare);
                break;
            case 'securityCode':
                formatTickerCell(cell, item, col, flare);
                break;
            case 'favWatchlist':
                formatFavWatchlistCell(cell, item, col, flare);
                break;
            case 'technicalAnalysis':
                formatTACell(cell, item, col, flare);
                break;
            case 'indicators':
                formatIndicatorsCell(cell, item, col, flare);
                break;
            case 'range52w':
                formatRange52wCell(cell, item, col, flare);
                break;
            default:
                cell.textContent = formatValueCell(item, col);
                break;
        }
    }

    const formatFavWatchlistCell = (cell, item, col, flare) => {
        cell.innerHTML = '';
        const container = document.createElement('div');
        cell.appendChild(container);
        const root = createRoot(container);
        root.render(
            <Provider store={store}>
                <WatchlistAddModal data={item} />
            </Provider>
        );
    };

    const formatTACell = (cell, item, col, flare) => {
        cell.innerHTML = '';
        const container = document.createElement('div');
        cell.appendChild(container);
        const root = createRoot(container);
        root.render(
            <div className='roboto-medium-14 taBg'>
                <FontAwesomeIcon className='technicalAnalysisIcon' icon={faChartLine}
                    onClick={() => clickGoTechnicalAnalysisPage(item)}
                />
            </div>
        );
    };

    const formatIndicatorsCell = (cell, item, col, flare) => {
        cell.innerHTML = '';
        const container = document.createElement('div');
        cell.appendChild(container);
        const root = createRoot(container);
        if (item.indicators && item.indicators.length > 0) {
            // if (item.indicators[0].currencyId) {
            //     item.indicators = item.indicators.filter((item) => item.currencyId == 1);
            // }
        }
        root.render(
            <div className='roboto-medium-14 taBg'>
                <ScoreFields data={item} />
            </div>
        );
    };

    const formatRange52wCell = (cell, item, col, flare) => {
        cell.innerHTML = '';
        const container = document.createElement('div');
        cell.appendChild(container);
        const root = createRoot(container);
        if (item.indicators && item.indicators.length > 0) {
            // if (item.indicators[0].currencyId) {
            //     item.indicators = item.indicators.filter((item) => item.currencyId == 1);
            // }
        }
        root.render(
            <div className='roboto-medium-14'>
                <Week52Range data={item} />
            </div>
        );
    };

    const formatDynamicCell = (cell, item, col, flare) => {
        if (item["HistoryRepository"] == undefined) return;
        var history = item.HistoryRepository[col.binding] || [];
        var value = formatValueCell(item, col);
        var prevValue = history.length > 1 ? formatValueCell({ [col.binding]: history[history.length - 2], pricePrecision: item.pricePrecision }, col) : value;
        var chg = history.length > 1 ? history[history.length - 1] / history[history.length - 2] - 1 : 0;
        var direction = chg > +0.000000001 ? 'up' : chg < -0.000000001 ? 'down' : null;
        cell.innerHTML = '';
        const container = document.createElement('div');
        cell.appendChild(container);
        const root = createRoot(container);
        root.render(
            <Blinker value={value} direction={direction}>
                <span className={`ticker chg-${direction || 'none'}`}>{value}</span>
            </Blinker>
        );
    }

    const formatChangeCell = (cell, item, col, flare) => {
        var value = formatValueCell(item, col);
        var prevValue = value;
        if (item["HistoryRepository"] && item["HistoryRepository"][col.binding] && item["HistoryRepository"][col.binding].length > 1) {
            prevValue = formatValueCell({ [col.binding]: item["HistoryRepository"][col.binding][item["HistoryRepository"][col.binding].length - 2], pricePrecision: item.pricePrecision }, col);
        }
        var direction = null;
        if (!isNaN(Number(value)) && !isNaN(Number(prevValue))) {
            direction = Number(value) > Number(prevValue) ? 'up' : Number(value) < Number(prevValue) ? 'down' : null;
        }
        cell.innerHTML = '';
        const container = document.createElement('div');
        cell.appendChild(container);
        const root = createRoot(container);
        root.render(
            <Blinker value={value} direction={direction}>
                <span className={`ticker flare-${direction || 'none'}`}>{value}</span>
            </Blinker>
        );
    }

    const formatSymbolCell = (cell, item, col, flare) => {
        var uniqueCode = item.code;
        var html = "<a class='securitySelect securityCode'> {uniqueCode}<a/>";
        html = html.replace(/{uniqueCode}/g, uniqueCode);
        cell.innerHTML = html;
        bindSecurityNavigation(cell, item.code);
    }

    const formatSymbolNameCell = (cell, item, col, flare) => {
        var uniqueCode = item.name;
        var html = "<a class='securitySelect securityCode elipsis-name'> {uniqueCode}<a/>";
        html = html.replace(/{uniqueCode}/g, uniqueCode);
        cell.innerHTML = html;
        bindSecurityNavigation(cell, item.code);
    }

    const formatTickerCell = (cell, item, col, flare) => {
        var uniqueCode = item.UniqueCode;
        var html = "<a class='securitySelect securityName'>  {uniqueCode}<a/>";
        html = html.replace(/{uniqueCode}/g, uniqueCode);
        cell.innerHTML = html;
        bindSecurityNavigation(cell, item.code);
    }

    // FlexGrid aynı DOM hücresini farklı satırlar için yeniden kullanır. Kod bilgisini
    // hücrede güncel tutup dinleyiciyi yalnızca bir kez bağlamak, filtreleme sonrasında
    // eski satıra ait click handler'ların birden fazla sekme açmasını engeller.
    const bindSecurityNavigation = (cell, code) => {
        cell.dataset.securityCode = code || '';

        if (cell.dataset.securityNavigationBound) return;

        cell.dataset.securityNavigationBound = 'true';
        cell.addEventListener('click', (event) => {
            const securityCode = event.currentTarget.dataset.securityCode;
            if (securityCode) {
                window.open(`/StockAnalysis/summary/${encodeURIComponent(securityCode)}`, '_blank');
            }
        });
    };

    const formatLastUpdateTimeCell = (cell, item, col, flare) => {
        var html = '';

        try {
            if (item == undefined) return;

            var lut = item['lastUpdateTime'];

            if (lut == undefined) return;

            html = moment.utc(lut, 'X').local().format('HH:mm:ss');
        } catch (e) {
            html = '';
        } finally {
            cell.innerHTML = html;
        }
    }

    const formatValueCell = (item, col) => {
        let cellValue = item[col.binding];
        let pricePrecision = item.pricePrecision;

        // WatchlistTable'daki gibi: null, undefined, boş string veya NaN ise tire göster
        if (cellValue === null || cellValue === undefined || cellValue === '' || (typeof cellValue === 'number' && isNaN(cellValue))) {
            return '-';
        }

        if (col.binding === 'marketCap') {
            try {
                cellValue = cellValue / 1000000.0;
            } catch (e) {
                return '-';
            }
        }

        switch (col.binding) {
            case 'dailyVolume':
            case 'lastVolume':
            case 'sharesInIssue':
            case 'marketCap':
                pricePrecision = 0;
                break;
            case 'rocPrevYear':
            case 'rocPrevWeek':
            case 'rocPrevMonth':
            case 'rocEOFPrevYear':
            case 'dailyChange':
                pricePrecision = 2;
                break;
            default:
                pricePrecision = item.pricePrecision;
                break;
        }

        // Sayısal formatlama
        if (col.dataType === 2) {
            const val = double(cellValue, pricePrecision);
            if (val === '' || val === null || val === undefined || (typeof val === 'number' && isNaN(val))) return '-';
            return val;
        }

        // Diğer formatlar
        const formatted = wjcCore.Globalize.format(cellValue, col.format);
        if (formatted === '' || formatted === null || formatted === undefined || formatted === 'NaN') return '-';
        return formatted;
    }

    const formatSortHeader = (cell, col, sortType) => {
        const container = document.createElement('div');
        container.className = "customSortIcon"
        cell.appendChild(container);
        const root = createRoot(container);
        let icon = ''
        if (sortType == 'default') icon = <FontAwesomeIcon key="sort" icon={faSort} className='sort-icon' />
        if (sortType == 'up') icon = <FontAwesomeIcon key="sort-up" icon={faSortUp} className='sort-icon' />
        if (sortType == 'down') icon = <FontAwesomeIcon key="sort-down" icon={faSortDown} className='sort-icon' />

        root.render(icon);
    };

    const clickGoTechnicalAnalysisPage = (data) => {
        try {
            // store selected security and navigate to technicalAnalysis without URL param
            const id = data.entityId;
            if (id !== undefined) {
                const selectedSecurity = {
                    id: id,
                    objectId: id,
                    code: data.UniqueCode || data.code,
                    name: data.name || data.symbolName
                };
                localStorage.setItem('selectedSecurity', JSON.stringify(selectedSecurity));
                toast.current.show({ severity: 'info', summary: 'Teknik Analiz Sayfasına Yönlendiriliyorsunuz', detail: 'Lütfen Bekleyiniz...', life: 3000 });
                navigate("/technicalAnalysis");
            } else {
                toast.current.show({ severity: 'error', summary: 'EntityId bulunamadı.', detail: 'Teknik Analiz Sayfasına Yönlendirilemedi', life: 3000 });
            }
        } catch (error) {
            console.log('clickGoTechnicalAnalysisPage error: ', error);
        }
    }

    const applyGridFilter = (searchTerm) => {
        const view = flex.current?.collectionView;
        if (!view) return;

        const normalizedSearchTerm = searchTerm.trim().toLowerCase();
        view.filter = normalizedSearchTerm
            ? item => lodash.some(item, value =>
                typeof value === "string" && value.toLowerCase().includes(normalizedSearchTerm)
            )
            : null;
        view.refresh();
    };

    const handleSearchChange = (event) => {
        const value = event.target.value;
        searchTermRef.current = value;
        isSearchInputActive.current = value.length > 0;
        clearTimeout(searchDebounceRef.current);

        searchDebounceRef.current = setTimeout(() => {
            applyGridFilter(value);
            isSearchInputActive.current = false;
        }, 150);
    };

    return (
        <div className='wijmo-table'>
            <Toast ref={toast} position='bottom-right' />
            <Container className=''  >
                <Row>
                    <Col md='4' sm='7'></Col>
                    <Col md='8' sm='5' className='float-right'></Col>
                </Row>
            </Container>
            {props.symbolListData.length === 0 && <ErrorView />}
            {props.symbolListData.length > 0 && (
                <>
                    <div className='search-input'>
                        <InputText onChange={handleSearchChange} className="gridSearch" placeholder={t('seachSymbolShare')} />
                    </div>
                    <FlexGrid
                        ref={theGridRef}
                        className="liveQuotesGrid"
                        initialized={initializeGrid}
                        itemsSource={gridRows}
                        style={{ maxHeight: '900px' }}
                        virtualizationThreshold={400}
                        selectionMode="None"
                        isReadOnly={true}
                        headersVisibility={"Column"}
                        allowMerging={0}
                        allowDragging={false}
                        allowDelete={false}
                        allowAddNew={false}
                    >
                        {columnsData && columnsData.map((col, i) => {
                            return <FlexGridColumn key={i} binding={col.binding} header={col.header} width={col.width} format={col.format} align={col.align} visible={col.isVisible} />;
                        })}
                    </FlexGrid>
                </>
            )}
        </div>
    );
}

export default IndexAnalysisTable;
